const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://ninhbinh-api.cgis.asia/",
        media_url: "https://ninhbinh-api.cgis.asia/",
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName: "",
        workSpace: "ninhbinh",
        wmsBaseLink: "https://geo.cgis.asia/geoserver/ninhbinh/wms/",
  },
  production: {
      api: "https://ninhbinh-api.cgis.asia/",
      media_url: "https://ninhbinh-api.cgis.asia/",
      domainAdminSide: "https://admin.ninhbinh.cgis.asia",
      domainUserSide: "https://ninhbinh.cgis.asia",
      domainName: "ninhbinh.cgis.asia",
      workSpace: "ninhbinh",
      wmsBaseLink: "https://geo.cgis.asia/geoserver/ninhbinh/wms/",
  },
};

module.exports = apiEnvironment[env];
